module.exports = __webpack_public_path__ + "static/4refuel-logo-a0005cb5953aef469a5b22691fad4981.png";